import { Check } from 'lucide-react'
import { Badge, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@teach/ui'
import { cn } from '@/lib/utils'
import type { LanguageState } from '@/features/ai/studioStartTypes'
import { statusBadgeOf } from '../../lib/courseLanguages'

// Один размер у всех статусов.
const CHIP_SIZE = '!border-0 !px-1.5 !py-0.5 !text-[9px] !leading-none'

/** Чип статуса ЯЗЫКА ПЕРЕВОДА (§6.1) с подсказкой «что это значит» — один на
 *  меню языка и вкладку «Язык», чтобы оба места говорили одно и то же. У
 *  оригинала `status` — `null`, и чипа нет: его сигнал — точка наполненности.
 *  Провайдер свой: глобального `TooltipProvider` в приложении нет. Обёртка
 *  `span` — потому что `Badge` не пробрасывает `ref`, а тултип якорится по нему. */
export const LangStatusChip = ({
  state,
  className,
}: {
  state: LanguageState | null
  className?: string
}) => {
  const badge = statusBadgeOf(state?.status)
  if (!badge) return null
  // «Актуален» объяснять нечего: подсказка только у статусов, где автору есть что делать.
  if (badge.variant === 'success') {
    return (
      <span className={cn('inline-flex shrink-0', className)}>
        <Badge
          variant="success"
          className={cn(CHIP_SIZE, 'gap-0.5 !bg-success/15 !pl-0.5 !text-success')}
        >
          <span className="flex size-2.5 shrink-0 items-center justify-center rounded-full bg-success">
            <Check aria-hidden strokeWidth={3} className="size-1.5 text-success-foreground" />
          </span>
          {badge.label}
        </Badge>
      </span>
    )
  }
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn('inline-flex shrink-0', className)}>
            <Badge
              variant={badge.variant}
              className={cn(
                CHIP_SIZE,
                badge.variant === 'warning' ? '!bg-warning/15 !text-warning' : '!bg-foreground/10',
              )}
            >
              {badge.label}
            </Badge>
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-64 text-xs">{badge.hint}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
